/** @jsx jsx */
import { jsx } from "@emotion/react";
import Icon from "@material-ui/core/Icon";
import _groupBy from "lodash/groupBy";
import { FC, Fragment, useMemo } from "react";
import { Link } from "react-router-dom";
import { setPrimaryAsColor } from "../../../../../../assets/styles/styles";
import {
  DataSourceId,
  NotificationId,
  SystemMappingNotification,
} from "../../../../../../globalTypes";
import { useFormatMsg } from "../../../../../../hooks/useFormatMsg";
import { DeleteButton } from "../../../../../atoms/inputs/EwaButtons";
import {
  FabContainer,
  innerContainerCss,
  labelWrapperCss,
  notificationContainerCss,
  notificationMessageCss,
  NotificationRow,
  NotificationTitle,
} from "./styles";

export type Props = {
  messages: SystemMappingNotification[];
  dismissNotification: (id: NotificationId) => void;
  getMappingPageUrl: (id: DataSourceId) => string;
  onCardClick?: (id: NotificationId) => void;
};

const MappingCardList: FC<Props> = ({
  getMappingPageUrl,
  messages,
  dismissNotification,
  onCardClick,
}) => {
  const formatMsg = useFormatMsg();

  const msgsByDatasourceId = useMemo(
    () => _groupBy(messages, (msg) => msg.datasourceId),
    [messages]
  );

  const renderCard = (datasourceId: number) => {
    const msgsForDatasource = msgsByDatasourceId[datasourceId];
    if (!msgsForDatasource?.length) return null;

    const dismissId = msgsForDatasource[0]?.notificationId;
    const datasourceName = msgsForDatasource[0]?.datasourceName;
    const templateNames = msgsForDatasource
      .map((m) => m.templateName)
      .join(", ");

    const intlParams = { datasourceName, templateNames };

    return (
      <NotificationRow key={datasourceId}>
        <div css={notificationContainerCss}>
          <Link
            to={getMappingPageUrl(datasourceId)}
            onClick={() => onCardClick?.(datasourceId)}
            css={innerContainerCss}
          >
            <div css={labelWrapperCss}>
              <NotificationTitle>
                <Icon css={setPrimaryAsColor}>shuffle</Icon>
                <span>{formatMsg("notifications.system.title")}</span>
              </NotificationTitle>
              <span css={notificationMessageCss}>
                {formatMsg("notifications.system", intlParams)}
              </span>
            </div>
          </Link>
        </div>
        <FabContainer>
          <DeleteButton onClick={() => dismissNotification(dismissId)} />
        </FabContainer>
      </NotificationRow>
    );
  };

  return (
    <Fragment>
      {Object.keys(msgsByDatasourceId).map((id) => renderCard(Number(id)))}
    </Fragment>
  );
};

export default MappingCardList;
export type MappingCardListProps = Props;
